import { registerNamespaces } from "@/lib/i18n/dictionary";

import enProduct from "@/locales/en/product.json";
import enPricing from "@/locales/en/pricing.json";
import thProduct from "@/locales/th/product.json";
import thPricing from "@/locales/th/pricing.json";

/**
 * Copy for the two product routes, /product/crm and /product/pos.
 *
 * Kept out of `product.tsx` for the same reason `home-bundles.ts` is kept out
 * of `home.ts`: the route's `generateMetadata` and its Server Components read
 * these namespaces directly, and a Server Component importing a named export
 * through a `"use client"` module gets a client reference rather than the
 * object.
 *
 * `pricing` rides along because both pages quote plan features from it rather
 * than restating them — the same namespace the home page's pricing rail reads,
 * so a plan's feature list is written once.
 */
registerNamespaces({
  en: { product: enProduct, pricing: enPricing },
  th: { product: thProduct, pricing: thPricing },
});
